/*
  This is a temporary limit as in the Device Hierarchy is missing Incremental loading.
  Without this limit would the Device Hierarchy try to load all items for given level
    -> Not good as there can be thousands

    Task where the incremental loading will be fixed: WIOT-1395

 */
export const CHILD_LIMIT_FOR_DEVICE_HIERARCHY= 20;
